/**
 * Semáforo único del kit de tableros: un tono por estado, con su color de
 * relleno, el fondo/texto del chip y el token de codekit para las gráficas
 * (PieCharts) — así todos los tableros hablan el mismo color.
 * @author Diego Serrano <diego.serrano@repremundo.com.co>
 * @since 2026-09-14
 */
export const TONOS = {
  ROJO: { hex: "#E52E2E", chip: { background: "#FDEEEE", color: "#C42727" }, codekit: { colorCellChart: "error-500", bgColorCards: "error-100", iconColor: "error-400", textColor: "error-500" } },
  NARANJA: { hex: "#E59C2E", chip: { background: "#FBEFDE", color: "#59350F" }, codekit: { colorCellChart: "warning-500", bgColorCards: "warning-100", iconColor: "warning-600", textColor: "warning-600" } },
  AMARILLO: { hex: "#E9C84F", chip: { background: "#FBF6DE", color: "#6B5A0F" }, codekit: { colorCellChart: "warning-300", bgColorCards: "warning-100", iconColor: "warning-500", textColor: "warning-600" } },
  VERDE: { hex: "#22AF42", chip: { background: "#DDF7E2", color: "#0D5120" }, codekit: { colorCellChart: "success-500", bgColorCards: "success-100", iconColor: "success-600", textColor: "success-600" } },
  AZUL: { hex: "#2875B4", chip: { background: "#EEF4F9", color: "#22629B" }, codekit: { colorCellChart: "primary-500", bgColorCards: "primary-100", iconColor: "primary-600", textColor: "primary-600" } },
  MORADO: { hex: "#6E48C8", chip: { background: "#EFEAF9", color: "#4C2D8F" }, codekit: { colorCellChart: "accent-500", bgColorCards: "accent-100", iconColor: "accent-600", textColor: "accent-600" } },
  NAVY: { hex: "#0D3C60", chip: { background: "#E6EDF3", color: "#0D3C60" }, codekit: { colorCellChart: "primary-700", bgColorCards: "primary-100", iconColor: "primary-700", textColor: "primary-700" } },
  GRIS: { hex: "#A3A3A3", chip: { background: "#F5F5F5", color: "#737373" }, codekit: { colorCellChart: "neutral-400", bgColorCards: "neutral-100", iconColor: "neutral-500", textColor: "neutral-600" } },
};

/** Tono seguro: cualquier valor desconocido cae en GRIS */
export const tono = (nombre) => TONOS[nombre] ?? TONOS.GRIS;

/** Colores de las alertas (catálogo CIMS0057) expresados en tonos del kit */
/**
 * Colores PLENOS del semáforo de alertas (Diego 2026-09-21): rojo, naranja de verdad (no ámbar), amarillo y azul.
 * Fuente única para el widget de alertas y los trackings de alertas: fondo pleno con su texto legible encima, y la
 * versión suave (fondo claro + texto oscuro) para filas y chips.
 */
export const COLOR_ALERTA = {
  ROJA: { hex: "#E52E2E", sobre: "#FFFFFF", suave: "#FDEEEE", texto: "#C42727" },
  NARANJA: { hex: "#F26A1B", sobre: "#FFFFFF", suave: "#FDE6D6", texto: "#9A3F08" },
  AMARILLA: { hex: "#F5C518", sobre: "#3D3000", suave: "#FDF5D2", texto: "#6B5500" },
  AZUL: { hex: "#2875B4", sobre: "#FFFFFF", suave: "#EEF4F9", texto: "#22629B" },
};

export const TONO_ALERTA = { ROJA: "ROJO", NARANJA: "NARANJA", AMARILLA: "AMARILLO", AZUL: "AZUL" };
